import { render, staticRenderFns } from "./currencies.dropdown.vue?vue&type=template&id=4587ace4"
import script from "./currencies.dropdown.vue?vue&type=script&lang=js"
export * from "./currencies.dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports